// src/layouts/ProtectedLayout.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";

import RequireAuth from "../components/auth/RequireAuth";
import PainelFloatingButtons from "../pages/painel/PainelFloatingButtons";
import SaldoMoedaChip from "../components/saldomoeda/SaldoMoedaChip";

const API_BASE = process.env.REACT_APP_API_BASE;

const ROTAS_COM_MENU = ["/painel", "/cardapios", "/calendario", "/resumo"];

const ProtectedLayout = ({ children }) => {
  const location = useLocation();

  const mostrarMenu = ROTAS_COM_MENU.includes(location.pathname);

  const [saldoMoedas, setSaldoMoedas] = useState(null);

  // 🆕 extraída pra fora do useEffect, pra poder ser chamada pelo listener também
  const buscarSaldo = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/painel-dados.php`, {
        credentials: "include",
      });
      const data = await res.json();

      if (data.status === "sucesso") {
        setSaldoMoedas(data.saldo_moedas ?? 0);
      }
    } catch {}
  }, []);

  // Busca ao trocar de rota (comportamento que já existia)
  useEffect(() => {
    buscarSaldo();
  }, [location.pathname, buscarSaldo]);

  // 🆕 Busca também quando qualquer tela avisar que o saldo mudou
  useEffect(() => {
    window.addEventListener("saldo-moedas-atualizado", buscarSaldo);
    return () => {
      window.removeEventListener("saldo-moedas-atualizado", buscarSaldo);
    };
  }, [buscarSaldo]);

  return (
    <RequireAuth>
      {saldoMoedas !== null && <SaldoMoedaChip saldo={saldoMoedas} />}
      {children}
      {mostrarMenu && <PainelFloatingButtons />}
    </RequireAuth>
  );
};

export default ProtectedLayout;